// assets/ra-verified.js
// Modern Mood – Selo RA Verified Interativo
// Fluxo:
//   1) Clique no selo ➜ revela stamp
//   2) Clique no stamp ➜ abre Reclame Aqui (nova aba)
// O selo NÃO abre link diretamente.
// Incluir via {{ 'ra-verified.js' | asset_url | script_tag }} antes de </body>

(function(){
  document.addEventListener('DOMContentLoaded', function(){
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const SEL_SIZE = isMobile?36:44;           // diâmetro selo (px)
    const SEL_PAD  = isMobile?4:6;            // padding selo (px)
    const BTN_SIZE = isMobile?20:24;          // botão fechar (px)
    const STAMP_W  = isMobile?110:140;        // largura stamp (px)
    const R_GAP    = 12;                      // gap borda direita (px)
    const BETWEEN  = 10;                      // distância selo→stamp (px)

    let stampVisible = false;

    // Cria selo flutuante
    const badge = document.createElement('div');
    Object.assign(badge.style, {
      position: 'fixed', top: '50%', right: `${R_GAP}px`,
      width: `${SEL_SIZE}px`, height: `${SEL_SIZE}px`,
      transform: `translate(${SEL_SIZE}px, -50%)`, opacity: '0',
      padding: `${SEL_PAD}px`, background: '#fff', borderRadius: '50%',
      boxSizing: 'border-box', boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      cursor: 'pointer', transition: 'transform .4s ease, opacity .4s ease', zIndex: 10000
    });
    // Imagem do selo
    const badgeImg = new Image();
    badgeImg.src = 'https://cdn.shopify.com/s/files/1/0710/4498/9187/files/ra-favicon.png?v=1751230193';
    badgeImg.alt = 'Avalie‑nos no Reclame Aqui';
    Object.assign(badgeImg.style, { width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' });
    badge.appendChild(badgeImg);
    document.body.appendChild(badge);

    // Cria stamp oculto
    const stamp = new Image();
    stamp.src = 'https://cdn.shopify.com/s/files/1/0710/4498/9187/files/midiakit_modern_mood_generic_stamp.png?v=1751232452';
    stamp.alt = 'Modern Mood Stamp';
    Object.assign(stamp.style, {
      position: 'fixed', top: '50%', right: `${R_GAP + SEL_SIZE + BETWEEN}px`,
      width: `${STAMP_W}px`, height: 'auto',
      transform: `translate(${STAMP_W}px, -50%)`, opacity: '0',
      transition: 'transform .4s ease, opacity .4s ease', cursor: 'pointer', zIndex: 10001
    });
    document.body.appendChild(stamp);

    // Botão fechar
    const close = document.createElement('button');
    close.textContent = '×';
    Object.assign(close.style, {
      position: 'absolute', top: `-${BTN_SIZE/2}px`, right: `-${BTN_SIZE/2}px`,
      width: `${BTN_SIZE}px`, height: `${BTN_SIZE}px`, border: 'none', borderRadius: '50%',
      background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: '16px',
      lineHeight: `${BTN_SIZE}px`, textAlign: 'center', cursor: 'pointer',
      opacity: isMobile? '1':'0', transition: 'opacity .2s'
    });
    badge.appendChild(close);
    badge.addEventListener('mouseenter', () => { if(!isMobile) close.style.opacity = '1'; });
    badge.addEventListener('mouseleave', () => { if(!isMobile && !stampVisible) close.style.opacity = '0'; });

    // 1) Clique no selo → revela stamp
    badge.addEventListener('click', function(e){
      e.stopPropagation();
      if(!stampVisible){
        stampVisible = true;
        badge.style.pointerEvents = 'none'; // impede múltiplos cliques
        stamp.style.transform = 'translate(0, -50%)';
        stamp.style.opacity = '1';
      }
    });

    // 2) Clique no stamp → abre RA
    stamp.addEventListener('click', function(e){
      e.stopPropagation();
      window.open(
        'https://www.reclameaqui.com.br/empresa/57-958-155-willams-cavalcanti-santos-da-silva/?utm_source=site&utm_medium=stamp&utm_campaign=reclameaqui_click',
        '_blank'
      );
    });

    // Fecha tudo
    close.addEventListener('click', function(e){
      e.stopPropagation();
      badge.remove(); stamp.remove();
    });

    // Animação de entrada
    requestAnimationFrame(function(){
      badge.style.transform = 'translate(0, -50%)';
      badge.style.opacity   = '1';
    });
  });
})();
